module.exports = __webpack_public_path__ + "media/images/icons/material/whatsapp-d89b09dec52e1e198d1284a6ba09fcde.svg";